import { render, staticRenderFns } from "./clientModalBasic.vue?vue&type=template&id=7fcdd037&scoped=true&"
import script from "./clientModalBasic.vue?vue&type=script&lang=js&"
export * from "./clientModalBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcdd037",
  null
  
)

export default component.exports